// extracted by mini-css-extract-plugin
module.exports = {"menuItem":"style_menuItem__3e8Jb","content":"style_content__3ogBC"};